import React from "react";
import { useLocation } from "react-router-dom";
import avatarVideoMp4 from "../../assets/avatares/fase-final.mp4";
import ScenarioBar from "../../components/ScenarioBar";
import { ROUTES } from "../../utils/constants";
import { getScenarioNumByPath } from "../../utils/helpers";
import { useVideoWithSound } from "../../hooks/useVideoWithSound";
import Scenario2NextCta from "../Scenario2/Scenario2NextCta";
import "../StartGame.css";
import "./Scenario5.css";

export default function Scenario5Context1() {
	const location = useLocation();
	const activeScenario = getScenarioNumByPath(location.pathname);

	const { videoRef, canPlayWithSound } = useVideoWithSound({
		autoPlay: true,
		volume: 0.8,
	});

	return (
		<>
			<div className="start-game-page start-game-page--welcome sc5-context1-startgame">
				<div className="start-game-inner">
					<div className="start-game-grid">
						<div className="start-game-visual">
							<span className="start-game-badge">
								<span className="start-game-badge-dot" aria-hidden />
								Escenario 4 · Inversión
							</span>
							<div className="start-game-avatar-wrap">
								<div className="start-game-avatar-inner">
									<video
										ref={videoRef}
										autoPlay
										muted={!canPlayWithSound}
										playsInline
										preload="auto"
										aria-label="Presentación visual"
									>
										<source src={avatarVideoMp4} type="video/mp4" />
									</video>
								</div>
							</div>
						</div>
						<div className="start-game-panel">
							<h1 className="start-game-title">
								Fase{" "}
								<span className="start-game-title-accent">final</span>
							</h1>
							<p className="start-game-lead">
								Enhorabuena. Si has llegado hasta aquí y has conseguido acumular capital, es porque has demostrado conocer las raíces y valores de COBEGA. Cuanto mayor sea el capital reunido, más sólido es tu vínculo con nuestra historia, nuestros valores y nuestra familia.
							</p>
							<p className="start-game-lead start-game-lead-tight">
								Pero el camino aún no ha terminado. Todo lo que has visto, escuchado y aprendido hasta ahora será clave para superar la última prueba. Recuerda cuál es el verdadero objetivo: acceder a la información reservada destinada únicamente a quienes demuestren estar preparados para formar la COBEGA del futuro.
							</p>
							<div className="start-game-footer">
								<Scenario2NextCta
									navigateTo={ROUTES.SCENARIO5_CONTEXT2}
									activeScenario={activeScenario}
									label="Continuar"
								/>
							</div>
						</div>
					</div>
				</div>
			</div>
			<ScenarioBar activeScenario={activeScenario} />
		</>
	);
}
